module.exports = __webpack_public_path__ + "img/Blockhole Ventrue-logo.402b6a8d.svg";